export default __webpack_public_path__ + "static/12-52d4486abab1852d33121e337d0212b1.webp";